import * as React from 'react';

const HierarchicalDonutIcon = ({ selected, ...rest }) => (
  <svg
    width={46}
    height={46}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23 3.833C12.431 3.833 3.833 12.431 3.833 23S12.431 42.167 23 42.167 42.167 33.569 42.167 23 33.569 3.833 23 3.833Zm0 26.834c-4.227 0-7.667-3.44-7.667-7.667 0-4.227 3.44-7.667 7.667-7.667 4.227 0 7.667 3.44 7.667 7.667 0 4.227-3.44 7.667-7.667 7.667Z"
      fill={selected ? '#FFFFFF' : '#6879C4'}
      fillOpacity={0.35}
    />
    <path
      d="M24.917 3.931v11.6a7.665 7.665 0 0 1 5.472 5.552h11.68c-.9-8.878-8.29-16.29-17.152-17.152ZM23 42.167c3.02 0 5.87-.703 8.406-1.95l-5.72-9.83A7.6 7.6 0 0 1 23 30.667v11.5Z"
      fill={selected ? '#FFFFFF' : '#6879C4'}
    />
  </svg>
);

export default HierarchicalDonutIcon;
